import { Component, input } from '@angular/core';

import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import {
    TableRowData,
    hasDiscrepancies,
    hasFineDiscrepancies,
    hasStatus,
} from '@app/shared/models/table-data-types';
import {
    ColumnConfig,
    ColumnValue,
} from '@app/shared/services/view-configs/column-creator';

@Component({
    selector: 'app-discrepancies-display',
    standalone: true,
    imports: [MatIconModule, TranslateModule],
    template: `
        @if (hasDiscrepancies) {
            <div
                class="tw-flex tw-h-auto tw-flex-row tw-justify-start tw-align-middle">
                @if (hasRoughControl) {
                    <div class="tw-leading-6">
                        {{
                            'OUTGOING-GOODS.DELIVERY-NOTE-LIST-VIEW.ROUGH-CONTROL'
                                | translate
                        }}
                    </div>
                }
                @if (hasRoughControl && hasFineControl) {
                    <div class="tw-mx-1 tw-leading-6">|</div>
                }
                @if (hasFineControl) {
                    <div class="tw-leading-6">
                        {{
                            'OUTGOING-GOODS.DELIVERY-NOTE-LIST-VIEW.FINIT-CONTROL'
                                | translate
                        }}
                    </div>
                }
                <mat-icon
                    class="tw-ml-3"
                    svgIcon="red-error">
                </mat-icon>
            </div>
        }
    `,
})
export class DiscrepanciesDisplayComponent {
    value = input<ColumnValue>();
    row = input<TableRowData>();
    column = input<ColumnConfig>();
    index = input<number>(0);
    item = input<TableRowData>(); // legacy alias
    parentRow = input<TableRowData>(); // for expanded rows
    bundleStatus = input<string>();

    get rowData(): TableRowData {
        return (this.row() || this.item()) as TableRowData;
    }

    get hasRoughControl(): boolean {
        if (!hasDiscrepancies(this.rowData)) {
            return false;
        }
        const data = this.rowData as TableRowData & {
            discrepancies?: boolean;
            hasDiscrepancies?: boolean;
        };
        return !!(data.discrepancies || data.hasDiscrepancies);
    }

    get hasFineControl(): boolean {
        if (!hasFineDiscrepancies(this.rowData)) {
            return false;
        }
        const data = this.rowData as TableRowData & {
            fineDiscrepancies?: boolean;
            hasFineDiscrepancies?: boolean;
        };
        return !!(data.fineDiscrepancies || data.hasFineDiscrepancies);
    }

    get hasDiscrepancies(): boolean {
        return this.hasRoughControl || this.hasFineControl;
    }
}
